module.exports = __webpack_public_path__ + "img/level_txt_0.ca465e3b.png";